// acciones
export const SAGA_GET_TIPOTALLE = 'articuloReducer/SAGA_GET_TIPOTALLE'
export const SET_TIPOTALLE = 'articuloReducer/SET_TIPOTALLE' 

export const SAGA_GET_ARTICULO_COMPLETO = 'articuloReducer/SAGA_GET_ARTICULO_COMPLETO'
export const SET_ARTICULO_COMPLETO = 'articuloReducer/SET_ARTICULO_COMPLETO' 

export const SAGA_GET_LISTADO_ARTICULO = 'articuloReducer/SAGA_GET_LISTADO_ARTICULO'
export const SET_LISTADO_ARTICULO = 'articuloReducer/SET_LISTADO_ARTICULO' 

export const SAGA_GET_LISTADO_ENTRADA = 'articuloReducer/SAGA_GET_LISTADO_ENTRADA'
export const SAGA_GET_LISTADO_ARTICULOS_AUSENTES_EN_CATALOGO = 'articuloReducer/SAGA_GET_LISTADO_ARTICULOS_AUSENTES_EN_CATALOGO'
export const SET_LISTADO_ENTRADA = 'articuloReducer/SET_LISTADO_ENTRADA' 

export const SAGA_GET_IMAGEN_ARTICULO = 'articuloReducer/SAGA_GET_IMAGENES_ARTICULO'
export const SET_IMAGEN_ARTICULO = 'articuloReducer/SET_IMAGENES_ARTICULOS'
export const SET_IMAGEN_ORIGINAL_ARTICULO = 'articuloReducer/SET_IMAGEN_ORIGINAL_ARTICULO'

export const SAGA_GET_IMAGEN_STOCK = 'articuloReducer/SAGA_GET_IMAGEN_STOCK'
export const SET_IMAGEN_STOCK = 'articuloReducer/SET_IMAGEN_STOCK'

export const SAGA_SAVE_ARTICULO = 'articuloReducer/SAGA_SAVE_ARTICULO'
export const SAGA_SAVE_ARTICULO_GENERICO = 'articuloReducer/SAGA_SAVE_ARTICULO_GENERICO'
export const SAGA_SAVE_ARTICULO_IMAGEN = 'articuloReducer/SAGA_SAVE_ARTICULO_IMAGEN'
export const SAGA_SAVE_ARTICULO_IMAGEN_TALLECOLOR = 'articuloReducer/SAGA_SAVE_ARTICULO_IMAGEN_TALLECOLOR'
export const SAGA_SAVE_ARTICULO_BORRAR = 'articuloReducer/SAGA_SAVE_ARTICULO_BORRAR'
export const SAGA_SAVE_ARTICULO_ENTRADA_BORRAR = 'articuloReducer/SAGA_SAVE_ARTICULO_ENTRDA_BORRAR'
export const SAGA_SAVE_ARTICULO_ENTRADA_AGREGAR = 'articuloReducer/SAGA_SAVE_ARTICULO_ENTRDA_AGREGAR'

export const SET_ARTICULO_BORRADO = 'articuloReducer/SET_ARTICULO_BORRADO'
export const SET_ARTICULO_ENTRADA_BORRADO = 'articuloReducer/SET_ARTICULO_BORRADO'

export const SAGA_INITIAL_STATE = 'articuloReducer/SAGA_INITIAL_STATE'

export const SAGA_SAVE_ARTICULO_IMAGEN_RECORTE = 'articuloReducer/SAGA_SAVE_ARTICULO_IMAGEN_RECORTE'
export const SAGA_SAVE_ARTICULO_IMAGEN_TALLECOLOR_RECORTE = 'articuloReducer/SAGA_SAVE_ARTICULO_IMAGEN_TALLECOLOR_RECORTE'

export const SAGA_ELIMINAR_IMAGEN_ARTICULO = 'articuloReducer/SAGA_ELIMINAR_IMAGEN_ARTICULO'

export const SAGA_ELIMINAR_IMAGEN_TALLECOLOR = 'articuloReducer/SAGA_ELIMINAR_IMAGEN_TALLECOLOR'

export const SAGA_INCREMENTAR_CONTADOR = 'articuloReducer/SAGA_INCREMENTAR_CONTADOR'
export const SAGA_DECREMENTAR_CONTADOR = 'articuloReducer/SAGA_DECREMENTAR_CONTADOR'

export const SAGA_GET_IMAGEN_ARTICULO_LISTADO = 'articuloReducer/SAGA_GET_IMAGENES_ARTICULO_LISTADO'
export const SAGA_SET_IMAGEN_ARTICULO_LISTADO = 'articuloReducer/SAGA_SET_IMAGENES_ARTICULO_LISTADO'

export const SET_FILTERS_BUSQUEDA_ARTICULO = 'articuloReducer/SET_FILTERS_BUSQUEDA_ARTICULO'


// funciones

export const sagaGetImagenesListadoArticulos = (payload) =>({
    type: SAGA_GET_IMAGEN_ARTICULO_LISTADO,
    payload
})

export const sagaSetImagenesListadoArticulos = (payload) =>({
    type: SAGA_SET_IMAGEN_ARTICULO_LISTADO,
    payload
})

export const sagaGetListadoArticulos = (payload) =>({
    type: SAGA_GET_LISTADO_ARTICULO,
    payload
})


export const sagaGetListadoEntradas = (payload) =>({
    type: SAGA_GET_LISTADO_ENTRADA,
    payload
})


export const sagaGetListadoArticulosAusentesEnCatalogo = (payload) =>({
    type: SAGA_GET_LISTADO_ARTICULOS_AUSENTES_EN_CATALOGO,
    payload
})


export const setListadoArticulos = (payload) =>({
    type: SET_LISTADO_ARTICULO,
    payload
})

export const setListadoEntradas = (payload) =>({
    type: SET_LISTADO_ENTRADA,
    payload
})


export const sagaInitialStateArticulo = () =>({
    type: SAGA_INITIAL_STATE
})

export const sagaGetTipotalle = (payload) =>({
    type: SAGA_GET_TIPOTALLE,
    payload  
})

export const setTipotalle = (payload) =>({
    type: SET_TIPOTALLE,
    payload
})

export const sagaSaveArticulo = (payload) =>({
    type: SAGA_SAVE_ARTICULO,
    payload
})

export const sagaSaveArticuloGenerico = (payload) =>({
    type: SAGA_SAVE_ARTICULO_GENERICO,
    payload
})

export const sagaSaveArticuloImagen = (payload) =>({
    type: SAGA_SAVE_ARTICULO_IMAGEN,
    payload
})

export const sagaSaveBorrarArticulo = (payload) =>({
    type: SAGA_SAVE_ARTICULO_BORRAR,
    payload 
})

export const sagaSaveBorrarArticuloEntrada = (payload) =>({
    type: SAGA_SAVE_ARTICULO_ENTRADA_BORRAR,
    payload 
})

export const sagaSaveAgregarArticuloEntrada = (payload) =>({
    type: SAGA_SAVE_ARTICULO_ENTRADA_AGREGAR,
    payload 
})


export const setArticuloBorrado = (payload) =>({
    type: SET_ARTICULO_BORRADO,
    payload
})

export const setArticuloEntradaBorrado = (payload) =>({
    type: SET_ARTICULO_ENTRADA_BORRADO,
    payload
})

export const sagaSaveArticuloImagenTallecolor = (payload) =>({
    type: SAGA_SAVE_ARTICULO_IMAGEN_TALLECOLOR,
    payload
})

export const sagaGetArticuloCompleto = (payload) =>({
    type: SAGA_GET_ARTICULO_COMPLETO,
    payload
})

export const setArticuloCompleto = (payload) =>({
    type: SET_ARTICULO_COMPLETO,
    payload  
})

export const sagaGetArticuloImagen = (payload) => ({
    type: SAGA_GET_IMAGEN_ARTICULO,
    payload
})

export const setArticuloImagen = (payload) => ({
    type: SET_IMAGEN_ARTICULO,
    payload
})

export const setArticuloImagenOriginal = (payload) => ({
    type: SET_IMAGEN_ORIGINAL_ARTICULO,
    payload
})

export const sagaSaveArticuloImagenRecorte = (payload) =>({
    type: SAGA_SAVE_ARTICULO_IMAGEN_RECORTE,
    payload
})

export const sagaSaveTalleColorImagenRecorte = (payload) =>({
    type: SAGA_SAVE_ARTICULO_IMAGEN_TALLECOLOR_RECORTE,
    payload
})

export const sagaEliminarImagenArticulo = (payload) =>({
    type: SAGA_ELIMINAR_IMAGEN_ARTICULO,
    payload
})

export const sagaGetStockImagen = (payload) => ({
    type: SAGA_GET_IMAGEN_STOCK,
    payload
})

export const setStockImagen = (payload) => ({
    type: SET_IMAGEN_STOCK,
    payload
})

export const eliminarImagenTalleColor = (payload) => ({
    type: SAGA_ELIMINAR_IMAGEN_TALLECOLOR,
    payload
})

export const incrementarContadorTemporal = () => ({
    type: SAGA_INCREMENTAR_CONTADOR,
})

export const setFilterBusquedaArticulo = (payload) => ({
    type: SET_FILTERS_BUSQUEDA_ARTICULO,
    payload
})